import {createAsyncThunk, createSlice, current} from "@reduxjs/toolkit";
import {getAllUnUsedEventsAPI, setCameraEventToUsedAPI} from "../../api/camera";

export const fetchAllUnusedEvents = createAsyncThunk(
    "fetchAllUnusedEvents", async ({
                                       filter, params
                                   }) => {
        return (await getAllUnUsedEventsAPI(filter, params)).data
    })

const initialState = {
    notifications: [],
    maxNotifications: 30,
    cameraConfig: [],
    unUsedEvents: {
        content: [],
        totalElements: 0,
    },
    loading: false
}

function findOldestUnusedIndex(notifications) {
    for (let i = notifications.length - 1; i >= 0; i--) {
        if (!notifications[i].trafficLogId) {
            return i;
        }
    }
    return -1;
}

const slice = createSlice({
    name: 'camera',
    initialState,
    reducers: {
        setCameraConfig: (state, {payload}) => {
            state.cameraConfig = payload;
            if (payload.length > 0 && payload[0].maxNotifications) {
                state.maxNotifications = payload[0].maxNotifications;
            }
        },
        removeCameraNotification: (state, {payload}) => {
            if(payload.trafficLogId){
                setCameraEventToUsedAPI({
                    id: payload.id,
                    trafficLogId: payload.trafficLogId,
                }).then(() => {
                    console.debug('setCameraEventToUsedAPI SUCCESS')
                })
            }
            const arr = [...current(state.notifications)];
            const index = arr.findIndex(value => value.id === payload.id);
            arr.splice(index, 1);
            state.notifications = arr;
        },
        addCameraNotification: (state, { payload }) => {
            const arr = [...current(state.notifications)];
            const index = arr.findIndex(v => v.id === payload.id);

            if (index === -1) {
                if (arr.length >= state.maxNotifications) {
                    const oldestUnusedIdx = findOldestUnusedIndex(arr);
                    if (oldestUnusedIdx !== -1) {
                        arr.splice(oldestUnusedIdx, 1);
                    } else {
                        arr.pop();
                    }
                }
                arr.unshift(payload);
                state.notifications = arr;
            }
        },
        removeCameraNotificationFromBE: (state, {payload}) => {
            state.notifications = state.notifications.filter((item) => item.id !== payload);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllUnusedEvents.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchAllUnusedEvents.fulfilled, (state, {payload}) => {
                state.unUsedEvents = payload;
                state.loading = false
            })
            .addCase(fetchAllUnusedEvents.rejected, (state) => {
                state.loading = false
            })
    },
});

export const {
    setCameraConfig,
    removeCameraNotification,
    addCameraNotification,
    removeCameraNotificationFromBE
} = slice.actions;
export default slice.reducer;
